import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=1bc12cb8&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=ts"
export * from "./MenuItem.vue?vue&type=script&lang=ts"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=1bc12cb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc12cb8",
  null
  
)

export default component.exports